import { Icon3d3d, Icon3dCycle, Icon3dDetect, Icon3dMeter } from '@assets/images/icon';
import { cameraBannerBg } from '@assets/images/main/camera';
import { IconGpsDeviceOff, IconGpsDeviceOn, IconGpsTagOff, IconGpsTagOn, IconOsOff, IconOsOn } from '@assets/images/main/icon';
import { IconBlueShield } from '@assets/images/main/icon/blue';
import { loraGatewayOn, loraGatewayOff, loraSensorOn, loraSensorOff, airOn, airOff, coOn, coOff, IconAlarm } from '@assets/images/main/index';
import { outdoorBannerImg } from '@assets/images/main/outdoor';
import { screenViewOutdoor1, screenViewOutdoor2, screenViewOutdoor3 } from '@assets/images/main/screenView';

import { ReactComponent as SvgBinocularsLine } from '@assets/images/icon/svg/binoculars-line.svg';
import { ReactComponent as SvgGlobal } from '@assets/images/icon/svg/global.svg';
import { ReactComponent as SvgPhoneLine } from '@assets/images/icon/svg/phone-line.svg';

export default {
  banner: {
    title: '広大な空間も、移動する資産も、<br/>ORBRO画面でシンプルに。',
    desc: '車両、資産、機器の動きをGPSで追跡し、<br/>LTEおよびLoRA受信機を通じてリアルタイム位置情報がORBRO OSと連携されます。',
    schemeTitle: 'あなたに合った屋外位置追跡の方法を見つけましょう',
    bgImg: cameraBannerBg,
    productImg: outdoorBannerImg,
  },

  bannerData: [
    {
      icon: IconGpsDeviceOn,
      iconInv: IconGpsDeviceOff,
      image: '',
      iconText: 'GPSデバイス',
      sub: 'New',
      link: '/jp/outdoor/gps',
    },
    {
      icon: IconGpsTagOn,
      iconInv: IconGpsTagOff,
      image: '',
      iconText: 'GPSタグ（LoRA）',
      sub: 'New',
      link: '/jp/outdoor/lora',
    },
  ],
  screenView: {
    title: 'すべてのモバイルの動きを一つの地図で',
    data: [
      { icon: SvgBinocularsLine, text: '監視センターモニタリング', img: screenViewOutdoor1 },
      { icon: SvgGlobal, text: '世界中の高解像度地図提供', img: screenViewOutdoor2 },
      { icon: SvgPhoneLine, text: 'モバイル機種とユーザー情報表示', img: screenViewOutdoor3 },
    ],
  },
  func: {
    title: 'カメラ機能を確認する',
    desc: 'カメラの多彩な機能をご確認ください。',

    data: [
      {
        img: IconBlueShield,
        title: '移動経路のリアルタイム追跡',
        desc: '車両、機器、コンテナなどの屋外資産の移動経路を地図上でリアルタイムに可視化し、現在位置と過去の移動履歴を一目で把握できます。',
      },
      {
        img: IconAlarm,
        title: 'ゾーン設定と逸脱検知',
        desc: '港湾、ヤード、道路作業エリアなどの特定区域を設定し、資産が出入りした際に自動でアラートを発信します。',
      },
      {
        img: Icon3dMeter,
        title: '機器稼働時間の分析',
        desc: 'GPSデータに基づき、車両や重機の稼働／待機／停止時間を自動分類し、稼働率と利用効率を分析できます。',
      },
      {
        img: Icon3dCycle,
        title: '速度異常の検知と通知',
        desc: '設定された速度基準を超えたり、予期しない移動パターンが発生した場合、管理者に自動で通知が送信されます。',
      },
      {
        img: Icon3dDetect,
        title: 'GPS端末のリモート監視',
        desc: '各端末のバッテリー残量、最終通信時刻、位置更新頻度などをサーバーでリモート確認し、異常があれば警告を発信します。',
      },
      {
        img: Icon3d3d,
        title: '資産別レポートの自動生成',
        desc: '資産ごとの位置履歴、滞在エリア、走行距離、出入ログなどをもとに、日／週／月単位の運用レポートを自動生成します。',
      },
    ],
  },

  FAQ: [
    {
      title: 'ORBROのGPS位置追跡システムはどのように動作しますか？',
      description:
        'GNSS（GPS）信号を受信する端末が屋外資産の位置をリアルタイムに計算し、LoRAまたはLTE-M通信を通じてORBROサーバーに送信します。位置情報はORBRO OS上で地図として可視化されます。',
    },
    {
      title: 'LoRA受信キットはどんな役割を果たしますか？',
      description:
        'LoRA受信キットはGPS端末から送信される信号を受信し、有線（PoE）通信でORBROサーバーにデータを送信します。広範囲に設置された受信機を通じてリアルタイムで位置データが連携されます。',
    },
    {
      title: '電源のない屋外でも使用できますか？',
      description:
        'GPS端末は内蔵バッテリーで最大150日間使用可能なため、電源インフラのない環境でも運用可能です。受信機はPoEを使用するため、電源が必要な固定設備です。',
    },
    {
      title: 'リアルタイム追跡は可能ですか？',
      description:
        'はい。GPS端末は定期的に位置を送信し、受信データはほぼリアルタイムでサーバーに反映されます。送信間隔は設定で調整可能で、通常は10秒〜1分間隔で設定されます。',
    },
    {
      title: 'GPSベースの位置追跡は屋内RTLSより優れていますか？',
      description:
        '状況によります。GPSは屋外環境に最適で、広いエリアや移動資産に適しています。一方、RTLSは高精度な屋内追跡に優れています。ORBROは屋内外の統合運用が可能です。',
    },
    {
      title: '位置データは保存されますか？',
      description:
        'はい。収集された位置データはORBROサーバーに保存され、資産別の移動履歴、入退記録、滞在時間分析などに活用されます。すべてのデータはアクセス権限と暗号化ポリシーにより安全に管理されます。',
    },
    {
      title: '端末の状態も確認できますか？',
      description: '可能です。各端末のバッテリー残量、最終通信時刻、信号品質などをORBRO OS上でリモート監視でき、異常時には自動で通知が送信されます。',
    },
    {
      title: 'リアルタイム通知は設定できますか？',
      description:
        'はい。指定エリアからの逸脱や、予期しない移動、異常な速度が検知された際に、管理者にリアルタイムで通知（プッシュ、メール、Webhookなど）を送信します。',
    },
  ],
};
